<template>
  <b-button-group>
    <b-button
      variant="warning"
      size="sm"
      class="mr-1 mb-1"
      :to="'/project/' + projectId">
      Details
    </b-button>
    <b-button
      v-if="surveyId"
      size="sm"
      class="mr-1 mb-1"
      :to="'/project/' + projectId + '/evaluation'">
      Evaluation
    </b-button>
    <b-button
      v-else
      size="sm"
      class="mr-1 mb-1"
      :to="'/project/' + projectId + '/evaluation/new'">
      Setup Evaluation
    </b-button>
    <b-button
      variant="primary"
      size="sm"
      class="mr-1 mb-1"
      :to="'/project/' + projectId + '#users-tab'">
      Users
    </b-button>
    <b-button
      variant="primary"
      size="sm"
      class="mr-1 mb-1"
      :to="'/project/' + projectId + '/project-metrics'">
      Action Items
    </b-button>
    <b-button
      v-if="status !== 'Closed'"
      variant="danger"
      size="sm"
      class="mb-1"
      :to="'/project/' + projectId + '/close'">
      Close Project
    </b-button>
  </b-button-group>
</template>

<script>
export default {
  props: {
    projectId: String,
    surveyId: String,
    status: String
  }
}
</script>